var React = require('react');

function Attention (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m49 25c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24zm-24-15.673v22.53m2.449 6.857a2.449 2.449 0 1 1 -4.898 0 2.449 2.449 0 0 1 4.898 0z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeWidth":"2"}));
}

Attention.defaultProps = {"height":"50","viewBox":"0 0 50 50","width":"50"};

module.exports = Attention;

Attention.default = Attention;
